import Api from "./Api.ts";

export const getAllUser = async () => {
  const response = await Api.get("/super-admin/users");
  return response.data;
};
